<template>
  <div style="display:flex;flex-direction:row;">
    <el-form
      :disabled="!isEditing"
      label-width="150px"
      label-position="right"
      style="margin-right:15px;"
    >
      <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('Message.Shipper')">
        <cargo-company-select
          :method-params="{shipper:true,active:true}"
          :headers="[$t('Partners.englishName')]"
          :fields="['englishName']"
          tag-name="englishName"
          :default-value="form.shipperId||''"
          style="width:190px;"
          :class="importDifferenceField.shipperId ? 'red-border' : ''"
          @change="p=>{shipperAutoCompleteChange(p)}"
        />
      </el-form-item>
      <booking-shipper-format-address
        ref="shipperFormatAddress"
        :country-list="countryList"
        :manifest-info="form"
        :is-sea-house-channel.sync="isSeaHouseChannel"
        :is-wse-channel.sync="isWseChannel"
        :is-ronge-tong.sync="isRongeTong"
        :is-editing="isEditing"
        :show-combined-manifest="showCombinedManifest"
        :special-character-check="specialCharacterCheck"
        :job="job"
      />
    </el-form>
    <el-form
      :disabled="!isEditing"
      label-width="150px"
      label-position="right"
      style="margin-right:15px"
    >
      <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('Message.Consignee')">
        <cargo-company-select
          :method-params="{consignee:true,active:true}"
          :headers="[$t('Partners.englishName')]"
          :fields="['englishName']"
          tag-name="englishName"
          :default-value="form.consigneeId||''"
          style="width:190px;"
          :class="importDifferenceField.consigneeId ? 'red-border' : ''"
          @change="p=>{consigneeAutoCompleteChange(p)}"
        />
      </el-form-item>
      <booking-consignee-format-address
        ref="consigneeFormatAddress"
        :country-list="countryList"
        :manifest-info="form"
        :is-sea-house-channel.sync="isSeaHouseChannel"
        :is-wse-channel.sync="isWseChannel"
        :is-ronge-tong.sync="isRongeTong"
        :is-editing="isEditing"
        :show-combined-manifest="showCombinedManifest"
        :special-character-check="specialCharacterCheck"
        :job="job"
      />
    </el-form>
    <el-form
      :disabled="!isEditing"
      label-width="150px"
      label-position="right"
      style="margin-right:15px"
    >
      <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('Message.Notify')">
        <cargo-company-select
          :method-params="{notify:true,active:true}"
          :headers="[$t('Partners.englishName')]"
          :fields="['englishName']"
          tag-name="englishName"
          :default-value="form.notifyId||''"
          style="width:190px;"
          :class="importDifferenceField.notifyId ? 'red-border' : ''"
          @change="p=>{notifyAutoCompleteChange(p)}"
        />
      </el-form-item>
      <booking-notify-format-address
        ref="notifyFormatAddress"
        :country-list="countryList"
        :manifest-info="form"
        :is-sea-house-channel.sync="isSeaHouseChannel"
        :is-wse-channel.sync="isWseChannel"
        :is-ronge-tong.sync="isRongeTong"
        :is-editing="isEditing"
        :show-combined-manifest="showCombinedManifest"
        :special-character-check="specialCharacterCheck"
        :job="job"
      />
    </el-form>
    <div class="section form-column" style="width: 520px;">
      <el-form v-if="!isAddSpelling">
        <el-form-item label-width="0" class="auto-width">
          <cargo-ag-grid
            :grid-options="edi.gridOptions"
            :column-defs="edi.columnDefs"
            :row-data="ediFinalRowData"
            :show-side-bar="false"
            style="width:100%;"
            @gridReady="params=>{edi.gridApi=params.api}"
          />
          <div style="padding:15px 0">
            <el-button type="primary" :disabled="isEdit" @click="onCount">{{ $t('SeaExport.Statistics') }}</el-button>
            <el-button type="primary" :disabled="!isEditing" @click="ediAdd">{{ $t('Payment.new') }}</el-button>
            <el-button :disabled="!(isEditing && ediFinalRowData.length > 1) || (Boolean(form.manifestId) && isSeaHouseChannel)" type="danger" @click="ediRemove">{{ $t('FileHistory.Delete') }}</el-button>
            <el-button type="primary" :disabled="isEdit" @click="ediValid">{{ $t('Payment.invalid') }}</el-button>
          </div>
        </el-form-item>

        <el-form-item v-if="edi.countVisible" label-width="0" class="auto-width">
          <el-row>
            <el-col :span="6">{{ $t('SeaExport.TotalCustomsNo') }}</el-col>
            <el-col :span="6">{{ $t('SeaExport.TotalNumberOfPieces') }}</el-col>
            <el-col :span="6">{{ $t('SeaExport.TotalGrossWeight') }}</el-col>
            <el-col :span="6">{{ $t('SeaExport.TotalVolume') }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="6"> {{ edi.btnSumSoNo }}个 </el-col>
            <el-col :span="6">{{ edi.btnSumQty }}</el-col>
            <el-col :span="6">{{ edi.btnSumWeight }}</el-col>
            <el-col :span="6">{{ edi.btnSumCubage }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="6">{{ $t('SeaExport.CustomsNoNotImported') }}</el-col>
            <el-col :span="12">
              <el-input v-model="edi.noExcelSoNo" :readonly="true" :disabled="true" type="textarea" :rows="7" />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <el-form v-if="isAddSpelling" label-width="100px" label-position="right">
      <el-form-item class="label-none custom">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="finalRowData"
          style="width:224px;height:200px"
          @gridReady="params=>{gridApi=params.api}"
        />
        <div style="padding:5px 0">
          <div style="float:right">
            <el-button type="primary" :disabled="!isEditing" @click="add">{{ $t('Payment.new') }}</el-button>
            <el-button :disabled="!(isEditing && finalRowData.length > 1)" type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import bookingShipperFormatAddress from '../bookingShipperFormatAddress'
import bookingConsigneeFormatAddress from '../bookingConsigneeFormatAddress'
import bookingNotifyFormatAddress from '../bookingNotifyFormatAddress'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { Company } from '@/class/model/mdm/Company'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { invalidManifest } from '@/api/seaExport/manifestInfo'
import { getLclSlaves, getLclSlavesAndManifests } from '@/api/seaExport/seaExportJob'
import * as NumberUtils from '@/utils/NumberUtils'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'

export default {
  name: 'BookingFormatAddressJc',
  components: { cargoAdvanceSelect, cargoCompanySelect, bookingShipperFormatAddress, bookingConsigneeFormatAddress, bookingNotifyFormatAddress },
  props: {
    job: { type: Object, default: () => {} },
    isEdit: { type: Boolean, required: true },
    isEditing: { type: Boolean, required: true },
    isAddSpelling: { type: Boolean, default: false },
    isSeaHouseChannel: { type: Boolean, default: false },
    isWseChannel: { type: Boolean, default: false },
    isRongeTong: { type: Boolean, default: false },
    specialCharacterCheck: { type: Boolean, default: false },
    showCombinedManifest: { type: Boolean, default: false }
  },
  data() {
    return {
      isSelect: false,
      selectData: [],
      selectTypeNames: TYPE_NAMES,
      form: new ManifestInfo().fillDefaultValue().getData(),
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 32,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked
      },
      rowData: [],
      gridApi: null,
      edi: {
        countVisible: false,
        btnSumSoNo: 0,
        btnSumQty: 0,
        btnSumWeight: 0,
        btnSumCubage: 0,
        noExcelSoNo: '',
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          onRowClicked: this.onRowClicked,
          onSelectionChanged: event => {
            this.isSelect = true
            this.selectData = event.api.getSelectedRows()
          }
        },
        rowData: [],
        gridApi: null,
        columnDefs: [
          { headerName: this.$t('SeaExport.SequenceNumber'), colId: 'sequence', field: 'sequence', width: 50, suppressMenu: true },
          { headerName: this.$t('SeaExport.ImportDate'), colId: 'dateCreated', field: 'dateCreated', width: 130,
            valueFormatter: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            } },
          { headerName: this.$t('SeaExport.ImportUser'), colId: 'createdBy', field: 'createdBy', width: 130,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            } },
          { headerName: this.$t('SeaExport.SendTag'), colId: 'ediSendDate', field: 'ediSendDate', width: 85,
            valueFormatter: (params) => {
              return ColumnUtils.booleanColumnLabelFunc(params.value)
            } },
          { headerName: this.$t('CargoMsg.Cargo_SentDate'), colId: 'ediSendDate', field: 'ediSendDate', width: 130,
            valueFormatter: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            } },
          { headerName: this.$t('SeaExport.SendUser'), colId: 'ediSenderId', field: 'ediSenderId', width: 130,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.SubtotalOfCustomsOrderNo'), colId: 'soNoNum', field: 'soNoNum', width: 100 },
          { headerName: this.$t('Invoice.invoice_invalidOrNot'), colId: 'invalid', field: 'invalid', width: 80, suppressMenu: true,
            valueFormatter: (params) => {
              return ColumnUtils.booleanColumnLabelFunc(params.value)
            } }
        ],
        curForm: null
      },
      thirdPartyMappingUtil: null,
      countryList: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.SoNo'),
          colId: 'soNo',
          field: 'soNo',
          width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEditing,
            tag: 'cargo-cell-input'
          }
        }
      ]
    },
    ediFinalRowData() {
      return this.edi.rowData.filter(p => !p.deleted) || []
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    notSeaHouseChannelOrWseChannel() {
      return !(this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong)
    },
    importDifferenceField() {
      if (!this.job) return {}
      return this.job.differencePrePlanFields || {}
    }
  },
  watch: {
    manifestInfo(newVal) {
      this.form = newVal
    },
    form(newVal) {
      this.$emit('update:manifestInfo', newVal)
    },
    manifestInfos(newVal) {
      this.edi.rowData = newVal
      this.rowData = newVal
    },
    rowData(newVal) {
      this.$emit('update:manifestInfos', newVal)
    },
    'manifestInfo.portOfLoading': {
      handler(val) {
        this.initCountryList()
      },
      deep: true
    }
  },
  created() {
    if (this.manifestInfos && this.manifestInfos.length > 0) {
      this.rowData = this.manifestInfos
    }
    this.init()
  },
  methods: {
    async init() {
      await this.initCountryList()
    },
    async initCountryList() {
      if (this.isSeaHouseChannel) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
      } else if (this.isWseChannel) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
      } else if (this.isRongeTong) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('rongeTong')
      } else {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
      }
      this.countryList = this.thirdPartyMappingUtil.getListByDataType('country')
    },
    toQuery(manifestInfos) {
      this.$nextTick(async() => {
        if (this.isAddSpelling) { // 加拼
          this.rowData = manifestInfos
          if (this.gridApi) {
            await sleep(100)
          } else {
            await ensureExecuteSuccess(() => this.gridApi)
          }
          let selectedNode = null
          if (this.gridApi) {
            const { rowsToDisplay } = this.gridApi.getModel()
            if (this.curForm) {
              selectedNode = rowsToDisplay.find(node => node.data.dateCreated === this.curForm.dateCreated) || rowsToDisplay[0]
            } else {
              selectedNode = rowsToDisplay[0]
            }
          }
          const selectedData = selectedNode ? selectedNode.data : this.finalRowData[0]
          if (selectedNode) {
            selectedNode.setSelected(true)
          }
          this.onRowClicked({ data: selectedData })
        } else {
          this.edi.countVisible = false
          this.edi.rowData = manifestInfos
          if (this.edi.gridApi) {
            await sleep(100)
          } else {
            await ensureExecuteSuccess(() => this.edi.gridApi)
          }
          let selectedNode = null
          if (this.edi.gridApi) {
            const { rowsToDisplay } = this.edi.gridApi.getModel()
            if (this.curForm) {
              selectedNode = rowsToDisplay.find(node => node.data.dateCreated === this.curForm.dateCreated) || rowsToDisplay[0]
            } else {
              selectedNode = rowsToDisplay[0]
            }
          }
          const selectedData = selectedNode ? selectedNode.data : this.ediFinalRowData[0]
          if (selectedNode) {
            selectedNode.setSelected(true)
          }
          this.onRowClicked({ data: selectedData })
        }
      })
    },
    reloadData(manifestInfos) {
      if (this.isAddSpelling) { // 加拼
        this.rowData = manifestInfos
        this.$nextTick(() => {
          if (this.gridApi) {
            const { rowsToDisplay } = this.gridApi.getModel()
            const selectedNode = rowsToDisplay[manifestInfos.length - 1]
            selectedNode.setSelected(true)
            this.onRowClicked({ data: this.rowData[manifestInfos.length - 1] })
          }
        })
      } else {
        this.edi.countVisible = false
        this.edi.rowData = manifestInfos
        this.$nextTick(() => {
          const { rowsToDisplay } = this.edi.gridApi.getModel()
          const selectedNode = rowsToDisplay[manifestInfos.length - 1]
          selectedNode.setSelected(true)
          this.onRowClicked({ data: this.edi.rowData[manifestInfos.length - 1] })
        })
      }
    },
    async shipperAutoCompleteChange(data) {
      this.form.shipperId = data.value || 0
      const manifestAddress = await new Company(data).getMainfestAddress()
      if (!manifestAddress) {
        return
      }
      this.form.shipperShortCode = manifestAddress.shortCode
      this.form.shipperEnterpriseCode = manifestAddress.enterpriseCode
      this.form.shipperEnterpriseName = manifestAddress.enterpriseName
      this.form.shipperAddress = manifestAddress.address
      this.form.shipperContactsType = manifestAddress.contactsType
      this.form.shipperContacts = manifestAddress.contacts
      this.form.shipperCityName = manifestAddress.cityName
      this.form.shipperProvinceCode = manifestAddress.provinceCode
      this.form.shipperProvinceName = manifestAddress.provinceName
      this.form.shipperZipCode = manifestAddress.zipCode
      this.form.shipperCountryCode = manifestAddress.countryCode
      this.form.shipperAeoEnterpriseCode = manifestAddress.aeoEnterpriseCode
    },
    async consigneeAutoCompleteChange(data) {
      this.form.consigneeId = data.value || 0
      const manifestAddress = await new Company(data).getMainfestAddress()
      if (!manifestAddress) {
        return
      }
      this.form.consigneeShortCode = manifestAddress.shortCode
      this.form.consigneeEnterpriseCode = manifestAddress.enterpriseCode
      this.form.consigneeEnterpriseName = manifestAddress.enterpriseName
      this.form.consigneeAddress = manifestAddress.address
      this.form.consigneeContactsType = manifestAddress.contactsType
      this.form.consigneeContacts = manifestAddress.contacts
      this.form.consigneeCityName = manifestAddress.cityName
      this.form.consigneeProvinceCode = manifestAddress.provinceCode
      this.form.consigneeProvinceName = manifestAddress.provinceName
      this.form.consigneeZipCode = manifestAddress.zipCode
      this.form.consigneeCountryCode = manifestAddress.countryCode
      this.form.consigneeAeoEnterpriseCode = manifestAddress.aeoEnterpriseCode
    },
    async notifyAutoCompleteChange(data) {
      this.form.notifyId = data.value || 0
      const manifestAddress = await new Company(data).getMainfestAddress()
      if (!manifestAddress) {
        return
      }
      this.form.notifyShortCode = manifestAddress.shortCode
      this.form.notifyEnterpriseCode = manifestAddress.enterpriseCode
      this.form.notifyEnterpriseName = manifestAddress.enterpriseName
      this.form.notifyAddress = manifestAddress.address
      this.form.notifyContactsType = manifestAddress.contactsType
      this.form.notifyContacts = manifestAddress.contacts
      this.form.notifyCityName = manifestAddress.cityName
      this.form.notifyProvinceCode = manifestAddress.provinceCode
      this.form.notifyProvinceName = manifestAddress.provinceName
      this.form.notifyZipCode = manifestAddress.zipCode
      this.form.notifyCountryCode = manifestAddress.countryCode
      this.form.notifyAeoEnterpriseCode = manifestAddress.aeoEnterpriseCode
    },
    add() {
      const newRow = new ManifestInfo().fillDefaultValue().getData()
      newRow.shipperCountryCode = 'CN'
      newRow.todo = 'new'
      this.rowData.push(newRow)
      setTimeout(() => {
        this.gridApi.setFocusedCell(this.finalRowData.length - 1)
        this.onRowClicked({ data: this.finalRowData[this.finalRowData.length - 1] })
      }, 100)
      // 清除错误提示
      this.changeAll()
      this.$emit('cleanUpAll')
    },
    setSelectNode(index) {
      const selectedNode = this.edi.gridApi.getModel().rowsToDisplay[index]
      selectedNode.setSelected(true)
    },
    onRowClicked(event) {
      if (!event.data) {
        // CARGO-44739 预配信息有值，切换到另一票无舱单数据的时候，仍会显示上一票的值
        this.form = new ManifestInfo().fillDefaultValue().getData()
        return
      }
      this.curForm = this.form = event.data
      this.$emit('curManifest', this.curForm)
      // 清除错误提示
      this.changeAll()
      this.$emit('cleanUpAll')
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.finalRowData[cell.rowIndex] : null
      if (row) {
        if (row.uuid) {
          row.deleted = true
          const tempRowData = this.rowData
          this.rowData = []
          this.$nextTick(() => {
            this.rowData = tempRowData
          })
        } else {
          const index = this.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
        }
        if (this.finalRowData.length > 0) {
          setTimeout(() => {
            this.gridApi.setFocusedCell(0)
            this.onRowClicked({ data: this.finalRowData[0] })
          }, 100)
        }
      }
    },
    checkModel(tabName) {
      if (this.isAddSpelling) {
        if (this.manifestInfos && this.manifestInfos.length > 0) {
          for (const item of this.manifestInfos) {
            if (!item.soNo) {
              throw new TabError(this.$t('SeaExport.CustomsNoCannotBeBlank'), tabName)
            }
          }
        }
      }
      this.$refs.shipperFormatAddress.checkModel(tabName)
      this.$refs.consigneeFormatAddress.checkModel(tabName)
      this.$refs.notifyFormatAddress.checkModel(tabName)
    },
    // 统计
    async onCount() {
      let sumSoNo = 0
      let sumQty = 0
      let sumWeight = 0.00
      let sumCubage = 0.00
      const soNoObj = new Map()

      const manifests = [...this.ediFinalRowData]

      let lclSlaves = []
      if (this.job.masterFlag && this.job.containerLoadType === 'BCF') {
        lclSlaves = await getLclSlavesAndManifests(this.job.uuid).then(res => res.data)
        for (const slave of lclSlaves) {
          if (slave.manifestInfos && slave.manifestInfos.length > 0) {
            for (const manifest of slave.manifestInfos) {
              if (manifest.manifestGoods) {
                for (const good of manifest.manifestGoods) {
                  good.quantity = 0
                  good.weight = 0
                  good.cubage = 0
                }
              }
            }
            manifests.push(...slave.manifestInfos)
          }
        }
      } else {
        lclSlaves = await getLclSlaves(this.job.uuid).then(res => res.data)
      }

      if (manifests && manifests.length > 0) {
        for (const manifest of manifests) {
          if (manifest.invalid) continue // 已作废舱单排除
          const goodsList = manifest.manifestGoods
          // 未作废的关单号 进行件毛体统计
          if (goodsList && goodsList.length > 0) {
            for (const good of goodsList) {
              if (good.soNo && !soNoObj.has(good.soNo)) {
                sumSoNo += 1
                soNoObj.set(good.soNo, good.soNo)
              }
              if (good.quantity && good.quantity > 0) {
                sumQty += good.quantity
              }
              if (good.weight && good.weight > 0) {
                sumWeight += good.weight
              }
              if (good.cubage && good.cubage > 0) {
                sumCubage += good.cubage
              }
            }
          }
        }
      }

      this.edi.btnSumSoNo = sumSoNo
      this.edi.btnSumQty = sumQty
      this.edi.btnSumWeight = NumberUtils.formatNumber(sumWeight, 3)
      this.edi.btnSumCubage = NumberUtils.formatNumber(sumCubage, 3)

      // 以下是订舱页签所有的关单号【包含主小票】
      let soNoLabel = this.job.soNo || ''
      if (lclSlaves && lclSlaves.length > 0) {
        for (const lcl of lclSlaves) {
          if (!lcl.soNo) {
            continue
          }
          if (soNoLabel) soNoLabel += '\n'
          soNoLabel += lcl.soNo
        }
      }
      if (soNoLabel) {
        const allSoNos = soNoLabel.split('\n')
        const useSoNos = []
        for (const soNo of allSoNos) {
          if (soNoObj.has(soNo) && soNoObj.get(soNo) === soNo) {
            continue
          }
          useSoNos.push(soNo)
        }
        // 去重
        this.edi.noExcelSoNo = [...new Set(useSoNos)].join('\n') || ''
      }
      this.edi.countVisible = true
    },
    // 新增舱单信息
    ediAdd() {
      console.log('this.ediFinalRowData', this.ediFinalRowData)
      // const newRow = new ManifestInfo().fillDefaultValue().getData()
      let newRow = []
      // 批次列表做过选择操作则取选中行数据,否则取新增后的最后一条，即上一条作为新增项默认数据
      if (this.isSelect) {
        newRow = JSON.parse(JSON.stringify(...this.selectData))
      } else {
        newRow = JSON.parse(JSON.stringify(this.ediFinalRowData[this.ediFinalRowData.length - 1]))
      }
      console.log('newRow', newRow)
      this.isSelect = false
      newRow.todo = 'new'
      newRow.jobUuid = this.job.uuid
      newRow.dateCreated = new Date()
      newRow.sequence = this.ediFinalRowData.length + 1
      newRow.soNoNum = 0
      newRow.uuid = ''
      newRow.version = 1
      newRow.manifestId = ''
      newRow.manifestGoods = []
      newRow.manifestVGMs = []
      console.log('newRow1111', newRow)
      this.edi.rowData.push(newRow)
      if (!this.job.manifestInfos) this.job.manifestInfos = []
      setTimeout(() => {
        this.edi.gridApi.clearFocusedCell()
        this.onRowClicked({ data: newRow })
        this.setSelectNode(this.ediFinalRowData.length - 1)
        this.edi.gridApi.refreshCells({ force: true }) // 刷新
      }, 100)
    },
    // 刷新序号
    ediRefresh() {
      if (this.edi.gridApi && this.ediFinalRowData.length > 0) {
        let seq = 0
        for (const item of this.ediFinalRowData) {
          seq++
          item.sequence = seq
        }
        this.edi.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 移除舱单信息
    ediRemove() {
      this.edi.gridApi.clearFocusedCell()
      const row = this.form
      if (row) {
        if (row.ediSendDate) {
          this.$message.warning('该舱单信息已发送过EDI,不允许删除.')
          return
        }

        if (row.uuid) {
          row.deleted = true
          const tempRowData = this.edi.rowData
          this.edi.rowData = []
          this.edi.rowData = tempRowData
        } else {
          const index = this.edi.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.edi.rowData.splice(index, 1)
          }
        }
        if (this.ediFinalRowData.length > 0) {
          this.ediRefresh()
          setTimeout(() => {
            this.onRowClicked({ data: this.ediFinalRowData[0] })
            this.setSelectNode(0)
          }, 100)
        }
      }
    },
    // 作废
    ediValid() {
      if (!this.form.uuid) return
      if (this.form.invalid) {
        this.$message.warning('该舱单已作废，不能再次作废。')
        return
      }
      this.$confirm(this.$t('SeaExport.ConfirmToVoid'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.loading = true
        invalidManifest({ manifestInfoUuid: this.form.uuid }).then(res => {
          if (res.data && res.data > 0) {
            this.form.invalid = true
            this.form.version += 1
            this.onRowClicked({ data: this.form })
            this.$message.success(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
            this.edi.gridApi.refreshCells({ force: true }) // 刷新
          }
        }).finally(() => {
          this.loading = false
        })
      }).catch()
    },
    changeAll() {
      this.$refs.shipperFormatAddress.validate()
      this.$refs.consigneeFormatAddress.validate()
      this.$refs.notifyFormatAddress.validate()
    },
    changeTip(row) {
      if (row.includes('shipper')) {
        this.$refs.shipperFormatAddress.validate()
      }
      if (row.includes('consignee')) {
        this.$refs.consigneeFormatAddress.validate()
      }
      if (row.includes('notify')) {
        this.$refs.notifyFormatAddress.validate()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    border: 1px solid red !important;
  }
}
</style>
